var e4 = e4 || {},
    alcadon = alcadon || {};

alcadon.tooltips = function () {
    jQuery( 'body' ).tooltip( {
        selector: '[data-toggle="tooltip"]'
    } );
};

alcadon.confirmLinks = function () {
    jQuery( document ).on( 'click', '.js-alcadon-confirm-link', function ( event ) {
        console.log( event );
        if ( window.confirm( jQuery( event.currentTarget ).data( 'confirmText' ) ) === false ) {
            event.preventDefault();
        }
    } );
};

alcadon.extranet = {
    init: function () {
        alcadon.extranet.validateEditUserForm();
        alcadon.extranet.dualAccount.init();
        alcadon.extranet.bindEvents();
    },
    bindEvents: function () {
        jQuery( '.js-alcadon-add-user-form-usertype-input' ).on( 'change', function ( event ) {
            alcadon.extranet.setOrderConfirmationTypeInAddUserForm( event.target );
        } );
    },
    validateEditUserForm: function () {
        var jAlcadonFormEditUser = jQuery( '.js-alcadon-extranet-update-user-form' );
        e4.require.js( e4.settings.require.jQueryValidate, function () {
            jAlcadonFormEditUser.validate( {
                submitHandler: function ( domForm ) {
                    var fnDwFormSpamScript = null;

                    if ( domForm.hasAttribute( 'onsubsmit' ) === true ) {
                        // Read Dynamicweb spam script from form onsubmit attribute.
                        fnDwFormSpamScript = domForm.onsubsmit;
                    }
                    if ( jQuery.isFunction( fnDwFormSpamScript ) === true ) {
                        fnDwFormSpamScript.call( window, domForm );
                    }

                    jQuery.ajax( {
                        method: 'POST',
                        url: location.href,
                        data: jQuery( domForm ).serialize(),
                        dataType: 'html'
                    } ).done( function ( strHtml ) {
                        location.href = location.href.replace( '?updated=true', '' ) + '?updated=true';
                    } );
                }
            } );
        } );
    },
    setOrderConfirmationTypeInAddUserForm: function ( domNode ) {
        var jSelect = jQuery( domNode );
        jSelect.closest( 'form' ).find( '.js-alcadon-add-user-form-send-confirmation-input' ).prop( 'checked', function () {
            if ( jSelect.val() === 'light' ) {
                return false;
            }
            else {
                return true;
            }
        } ).trigger( 'change' );
    },
    dualAccount: {
        init: function () {
            var jDualAccountModal = jQuery( '.js-alcadon-dual-account-modal' );
            if ( jDualAccountModal.length === 1 ) {
                jDualAccountModal.modal( 'show' );
            }
        }
    },
    shipmentsAndOpenOrders: {
        init: function () {
            alcadon.extranet.shipmentsAndOpenOrders.shipments.init();
            alcadon.extranet.shipmentsAndOpenOrders.datepicker.init();
            jQuery( '.js-alcadon-form-loading' ).on( 'submit', function ( objEvent ) {
                jQuery( objEvent.target ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            } );
            jQuery( '.js-alcadon-link-with-loading' ).on( 'click', function ( objEvent ) {
                jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
            } );
        },
        shipments: {
            init: function () {
                alcadon.extranet.shipmentsAndOpenOrders.shipments.bindEvents().done( alcadon.extranet.shipmentsAndOpenOrders.shipments.showCollapseByLocationHash );
            },
            bindEvents: function () {
                e4.jsonpublisher.event = e4.util.registerEvents( 'jsonDone jsonFail load loaded', 'jsonpublisher' );
                return e4.require.js( e4.settings.require.handlebars, function () {
                    jQuery( '.js-alcadon-shipment-collapse' ).one( 'show.bs.collapse', function ( event ) {
                        event.preventDefault();
                        alcadon.extranet.shipmentsAndOpenOrders.shipments.loadDetailsOnCollapseShow( event.target );
                    } );
                } );
            },
            loadDetailsOnCollapseShow: function ( domNode ) {
                var domShipmentDetails = jQuery( domNode ).find( '.js-alcadon-shipment-details' ).get( 0 );
                e4.jsonpublisher.load( domShipmentDetails ).done( function () {
                    jQuery( domNode ).collapse( 'show' );
                } );
            },
            showCollapseByLocationHash: function () {
                var strLocationHash = e4.hash.getCurrentHashStringValue();
                if ( strLocationHash.indexOf( 'shipmentNumber' ) === 0 ) {
                    jQuery( '#' + strLocationHash ).find( '.js-alcadon-shipment-collapse' ).collapse( 'show' );
                }
            }
        },
        datepicker: {
            init: function () {
                e4.require.js( e4.settings.require.datepicker, function () {
                    e4.require.js( e4.settings.require.datepickerLanguage, function () {
                        alcadon.extranet.shipmentsAndOpenOrders.datepicker.bindEvents();
                    } );
                } );
            },
            bindEvents: function () {
                jQuery( '.js-alcadon-extranet-shipments-and-open-orders-datepicker' ).datepicker( {} ).on( 'changeDate', function ( dateEvent ) {
                    alcadon.extranet.shipmentsAndOpenOrders.datepicker.updateDateInput( dateEvent );
                } );
            },
            updateDateInput: function ( dateEvent ) {
                var jTarget = jQuery( dateEvent.target );
                var strDateFormat = jTarget.data( 'date-format' ).toLowerCase();
                var strDateFormatted = dateEvent.format( strDateFormat );
                jTarget.closest( '.form-group' ).find( '.js-alcadon-extranet-shipments-and-open-orders-datepicker-input' ).val( strDateFormatted );
            }
        }
    }
};

alcadon.savedCarts = {
    init: function () {
        alcadon.savedCarts.bindEvents();

        if ( jQuery( '.js-saved-carts-product-list' ).length > 0 ) {
            alcadon.savedCarts.setCartQuantityOnListItem();
        }
    },
    bindEvents: function () {
        jQuery( document ).on( 'submit', '.js-alcadon-saved-carts-form', function ( event ) {
            event.preventDefault();
            alcadon.savedCarts.saveCart( event.target );
        } ).on( 'click', '.js-alcadon-saved-carts-delete', function ( event ) {
            event.preventDefault();
            var jSavedCartItem = jQuery( event.target ).closest( '.js-alcadon-saved-cart-item' );
            alcadon.savedCarts.deleteCart( jSavedCartItem );
        } ).on( 'click', '.js-alcadon-saved-carts-restore', function () {
            alcadon.savedCarts.restoreCart();
        } ).on( 'show.bs.modal', '.js-alcadon-saved-carts-list-modal', function ( event ) {
            var jSavedCartItem = jQuery( event.relatedTarget ).closest( '.js-alcadon-saved-cart-item' ),
                jModal = jQuery( event.target ),
                currentName = jSavedCartItem.data( 'cartName' ),
                currentId = jSavedCartItem.data( 'cartId' );
            jModal.find( '.js-alcadon-saved-carts-rename-list-form-id-input' ).val( currentId );
            jModal.find( '.js-alcadon-saved-carts-rename-list-form-name-input' ).val( currentName );
        } ).on( 'submit', '.js-alcadon-saved-carts-rename-list-form', function ( event ) {
            event.preventDefault();
            alcadon.savedCarts.renameCart( event.target );
        } );
    },
    renameCart: function ( domForm ) {
        jQuery.ajax( {
            data: jQuery( domForm ).serialize()
        } ).done( function () {
            location.reload();
        } );
    },
    saveCart: function ( domForm ) {
        e4.cart.ajax( {
            data: jQuery( domForm ).serialize()
        }, function () {
            location.href = domForm.dataset.redirectUrl;
        } );
    },
    restoreCart: function () {
        var jProductItems = jQuery( '.js-saved-carts-product-list' ).find( '.js-e-productlist-item' ),
            objFormData = {
                CartCmd: 'AddMulti',
                Redirect: false
            };

        jProductItems.each( function ( index, domElm ) {
            objFormData[ 'ProductLoopCounter' + index ] = index;
            objFormData[ 'ProductID' + index ] = jQuery( domElm ).data( 'productId' );
            objFormData[ 'VariantID' + index ] = jQuery( domElm ).data( 'variantId' );
            objFormData[ 'Quantity' + index ] = jQuery( domElm ).parent().data( 'quantity' );
        } );
        e4.cart.addProduct( objFormData );
    },
    deleteCart: function ( jSavedCartItem ) {
        var jCart = jQuery( '.js-e-cart' );
        if ( confirm( `Delete the saved cart "${ jSavedCartItem.data( 'cartName' ) }"` ) ) {
            e4.cart.ajax( {
                data: {
                    alcadonCartDeleteId: jSavedCartItem.data( 'cartId' )
                }
            }, function ( jsonData ) {
                jSavedCartItem.slideUp( function () {
                    jSavedCartItem.remove();
                    if ( jCart.length === 1 ) {
                        e4.cart.updateContent( jsonData );
                    }
                    else if ( jSavedCartItem.is( '.js-saved-carts-product-list' ) === true ) {
                        location.href = location.href.replace( location.search, '' );
                    }
                } );
            } );
        }
    },
    setCartQuantityOnListItem: function () {
        var jListItems = jQuery( '.js-saved-carts-product-list-item' );
        if ( jListItems.length > 0 ) {
            jListItems.each( function ( index, domItem ) {
                var jListItem = jQuery( domItem ),
                    jListItemCartQuantity = jListItem.data( 'quantity' ),
                    jSavedCartMsg = jListItem.find( '.js-alcadon-productlist-item-saved-cart-msg' );
                jSavedCartMsg.find( '.js-alcadon-productlist-item-saved-cart-msg-quantity' ).text( jListItemCartQuantity );
                jSavedCartMsg.removeClass( 'd-none' );
            } );
        }
    }
};

alcadon.ecom = {
    init: function () {
        alcadon.ecom.bindEvents();
        alcadon.ecom.toggleListView.init();
        alcadon.ecom.youtubeVideo.init();
    },
    bindEvents: function () {
        jQuery( '.js-alcadon-request-price-modal' ).on( 'show.bs.modal', function ( event ) {
            alcadon.ecom.requestPrice.buildModalContent( event );
            var jCartModal = jQuery( '.js-alcadon-add-to-cart-modal' );
            if ( jCartModal.length === 1 && jCartModal.data( 'bs.modal' ) !== undefined && jCartModal.data( 'bs.modal' )._isShown === true ) {
                jCartModal.modal( 'hide' );
            }
        } ).on( 'hidden.bs.modal', function ( event ) {
            alcadon.ecom.requestPrice.clearModalContent( event );
        } );
        jQuery( '.js-alcadon-request-price-modal, .js-alcadon-add-to-cart-modal' ).on( 'show.bs.modal', function ( event ) {
            if ( e4.hash.get( 'search' ) !== undefined ) {
                jQuery( event.target ).data( 'search-query-to-restore', e4.hash.get( 'search' ) );
                e4.hash.remove( 'search' );
            }
        } ).on( 'hidden.bs.modal', function ( event ) {
            var strSearchQueryToRestore = jQuery( event.target ).data( 'search-query-to-restore' );
            if ( strSearchQueryToRestore !== undefined && strSearchQueryToRestore !== null ) {
                e4.hash.set( 'search', strSearchQueryToRestore );
                jQuery( event.target ).data( 'search-query-to-restore', null );
            }
        } );
        jQuery( '.js-e-product, .js-alcadon-add-to-cart-modal' ).on( 'input change', '.js-e-add-to-cart-quantity-input', function ( event ) {
            alcadon.ecom.updateQuantityPrice( event.delegateTarget );
        } );
        jQuery( document ).on( 'input', '.js-e-add-to-cart-quantity-input', e4.util.debounce( function ( event ) {
            alcadon.ecom.validateQuantityInput( event.target );
        }, e4.settings.debounceDelay.input ) ).on( 'click', '.js-alcadon-add-to-cart-modal-btn', function ( event ) {
            alcadon.ecom.loadProductForm( event.target );
        } ).on( 'click', '.js-e-productlist-toggle-all', function ( event ) {
            event.preventDefault();
            if ( alcadon.ecom.toggleListView.toggleState !== event.currentTarget.dataset.toggle ) {
                alcadon.ecom.toggleListView.toggleAll( event.currentTarget, event.currentTarget.dataset.toggle );
            }
        } ).on( 'show.bs.dropdown', '.dropdown.js-e-product-favorites', function ( event ) {
            jQuery( event.target ).closest( '.js-e-productlist-item' ).addClass( 'has-open-dropdown' );
        } ).on( 'hidden.bs.dropdown', '.dropdown.js-e-product-favorites', function ( event ) {
            jQuery( event.target ).closest( '.js-e-productlist-item' ).removeClass( 'has-open-dropdown' );
        } );
    },
    toggleListView: {
        toggleState: 'collapsed',
        arrContextItems: [],
        init: function () {
            alcadon.ecom.toggleListView.bindEvents();
            if ( alcadon.ecom.toggleListView.toggleState !== '' ) {
                alcadon.ecom.toggleListView.toggleAll( null, alcadon.ecom.toggleListView.toggleState );
            }
            else {
                alcadon.ecom.toggleListView.set();
                alcadon.ecom.toggleListView.setActiveToggleAll();
            }
        },
        bindEvents: function () {
            jQuery( document ).on( 'click', '.js-e-productlist-item', function ( event ) {
                var jTarget = jQuery( event.target ),
                    jCurrentTarget = jQuery( event.currentTarget );
                if ( jTarget.closest( '.js-e-product-favorites, .alcadon-productlist-item-cart-col' ).length === 0 ) {
                    if ( jTarget.is( '[data-toggle="productItem"]' ) === false ) {
                        if ( jCurrentTarget.is( '.is-expanded' ) === true ) {
                            if ( e4.productListWithFacets !== undefined ) {
                                e4.productListWithFacets.products.navigateToProductPage( event.target );
                            }
                            else {
                                var strProductPageUrl = jQuery( event.target ).closest( '.js-e-productlist-item' ).find( 'a[href]' ).not( 'a[href="#"]' ).first().attr( 'href' );
                                console.log( strProductPageUrl );
                                location.href = strProductPageUrl;
                            }

                        }
                        else {
                            jCurrentTarget.find( '[data-toggle="productItem"]' ).first().trigger( 'click' );
                        }
                    }
                }
            } ).on( 'click', '[data-toggle="productItem"]', function ( event ) {
                event.preventDefault();
                alcadon.ecom.toggleListView.toggleState = '';
                alcadon.ecom.toggleListView.setActiveToggleAll();
                alcadon.ecom.toggleListView.toggle( event.target );
            } ).on( 'click', '.js-e-productlist-toggle-all', function ( event ) {
                event.preventDefault();
                alcadon.ecom.toggleListView.toggleAll( event.currentTarget, event.currentTarget.dataset.toggle );
            } );
        },
        setStateByProductlistContext: function ( objContext ) {
            alcadon.ecom.toggleListView.toggleState = objContext.expendedState;
            if ( alcadon.ecom.toggleListView.toggleState !== '' ) {
                alcadon.ecom.toggleListView.toggleAll( null, alcadon.ecom.toggleListView.toggleState );
            }
            else {
                alcadon.ecom.toggleListView.arrContextItems = objContext.expandedItems;
                alcadon.ecom.toggleListView.set();
                alcadon.ecom.toggleListView.setActiveToggleAll();
            }
        },
        get: function () {
            return jQuery( '.is-expanded' ).map( function ( intIndex, domNode ) {
                return domNode.id;
            } ).toArray();
        },
        set: function () {
            alcadon.ecom.toggleListView.arrContextItems.forEach( function ( strId ) {
                var domNode = document.getElementById( strId );
                if ( domNode !== null ) {
                    alcadon.ecom.toggleListView.toggle( domNode );
                    alcadon.ecom.toggleListView.arrContextItems = alcadon.ecom.toggleListView.arrContextItems.filter( i => i !== strId );
                }
            } );
        },
        toggle: function ( domNode ) {
            var jItem = jQuery( domNode ).closest( '.js-e-productlist-item' );
            if ( jItem.is( '.is-expanded' ) === false ) {
                jItem.addClass( 'is-expanded' );
                jItem.removeClass( 'is-collapsed' );
            }
            else {
                jItem.removeClass( 'is-expanded' );
                jItem.addClass( 'is-collapsed' );
            }
        },
        toggleAll: function ( domElm, strToggleState ) {
            var jToggleContainer = domElm !== null ? jQuery( domElm ).closest( '.js-alcadon-productlist-toggle-container' ) : null;
            var listItems = jToggleContainer !== null ? jQuery( domElm ).closest( '.js-alcadon-productlist-toggle-container' ).find( '.js-e-productlist-item' ) : jQuery( '.js-e-productlist-item' );
            alcadon.ecom.toggleListView.toggleState = strToggleState;
            listItems.each( function ( intIndex, domNode ) {
                if ( strToggleState === 'expanded' ) {
                    jQuery( domNode ).addClass( 'is-expanded' );
                    jQuery( domNode ).removeClass( 'is-collapsed' );
                }
                else if ( strToggleState === 'collapsed' ) {
                    jQuery( domNode ).addClass( 'is-collapsed' );
                    jQuery( domNode ).removeClass( 'is-expanded' );
                }
            } );
            if ( e4.productListWithFacets !== undefined ) {
                e4.productListWithFacets.context.set( {
                    expendedState: alcadon.ecom.toggleListView.toggleState
                } );
            }

            alcadon.ecom.toggleListView.setActiveToggleAll();
        },
        setActiveToggleAll: function () {
            jQuery( '.e-productlist-listview-toggle' ).removeClass( 'active' );
            jQuery( '.js-e-productlist-toggle-all[data-toggle="' + alcadon.ecom.toggleListView.toggleState + '"]' ).find( '.e-productlist-listview-toggle' ).addClass( 'active' );
        }
    },
    requestPrice: {
        buildModalContent: function ( event ) {
            var jProduct = jQuery( event.relatedTarget ).closest( '.js-e-productlist-item, .js-e-product' ),
                strProductNumber = jProduct.data( 'productNumber' ),
                strProductName = jProduct.data( 'productName' );
            jQuery.ajax( {
                url: 'system/global-content/request-price-form',
                dataType: 'html'
            } ).done( function ( strHtml ) {
                var jContentHtml = jQuery( strHtml ).find( '.js-e-content' ).find( '.container-fluid' ).first(),
                    jModal = jQuery( event.target );
                jContentHtml.find( '.js-alcadon-request-price-form-productId' ).val( strProductNumber );
                jContentHtml.find( '.js-alcadon-request-price-form-productName' ).val( strProductName );
                jModal.find( '.js-alcadon-request-price-content' ).html( jContentHtml.html() );
                jModal.modal( 'handleUpdate' );
                jModal.find( 'form' ).validate( {
                    submitHandler: alcadon.ecom.requestPrice.formSubmitHandler
                } );
            } );
        },
        clearModalContent: function ( event ) {
            jQuery( event.target ).find( '.js-alcadon-request-price-content' ).html( '' );
        },
        formSubmitHandler: function ( domForm ) {
            var jForm = jQuery( domForm ),
                fnDwFormSpamScript = e4.data.get( 'forms.dwSpamScripts.' + domForm.id );
            if ( jQuery.isFunction( fnDwFormSpamScript ) === true ) {
                fnDwFormSpamScript.call( window, domForm );
            }
            if ( domForm.elements[ e4.settings.forms.submitPageFieldName ] !== undefined ) {
                domForm.elements[ e4.settings.forms.submitPageFieldName ].value = location.href;
            }
            e4.util.disableAllSubmitButtonsInForm( domForm );
            jQuery.ajax( {
                url: jForm.attr( 'action' ),
                dataType: 'html',
                data: jForm.serialize(),
                method: 'POST'
            } ).done( function ( strHtml ) {
                var jContentHtml = jQuery( strHtml ).find( '.js-e-content' ).find( '.container-fluid' ).first(),
                    jModal = jQuery( domForm ).closest( '.modal' );
                jModal.find( '.js-alcadon-request-price-content' ).html( jContentHtml.html() ).find( '.btn' ).on( 'click', function ( event ) {
                    event.preventDefault();
                    jModal.modal( 'hide' );
                } );
                jModal.modal( 'handleUpdate' );
            } );
        },
    },
    loadProductForm: function ( domNode ) {
        var jModal = jQuery( '.js-alcadon-add-to-cart-modal' ),
            jProductListItem = jQuery( domNode ).closest( '.js-e-productlist-item' ),
            jProjectList = jProductListItem.closest( '.js-alcadon-project-list' );
        jQuery.ajax( {
            url: e4.settings.ecom.product.url,
            data: {
                productId: jProductListItem.data( 'productId' ),
                variantId: jProductListItem.data( 'variantId' ),
                projectId: jProjectList.data( 'projectId' ),
                projectName: jProjectList.data( 'projectName' )
            }
        } ).done( function ( json ) {
            jModal.find( '.js-alcadon-add-to-cart-modal-form-container' ).html( json.productFormHtml );
            jModal.find( '[name="AlcadonProjectId"]' ).val( jProjectList.data( 'projectId' ) );
            jModal.find( '[name="AlcadonProjectName"]' ).val( jProjectList.data( 'projectName' ) );
            alcadon.ecom.variants.bindVariantsOnModalForm( jModal );
            jModal.modal( 'show' );
        } );
    },
    validateQuantityInput: function ( domInput ) {
        var jInput = jQuery( domInput ),
            intInputCurrentValue = e4.util.formatStringToJavascriptNumber( jInput.val() ),
            intMinimumQuantity = e4.util.formatStringToJavascriptNumber( jInput.data( 'ruleMin' ) ),
            intStep = e4.util.formatStringToJavascriptNumber( jInput.data( 'step' ) ),
            intInputNewValue = null;
        if ( isNaN( intStep ) === true ) {
            intStep = 1;
            console.log( 'intStep value NaN, set to default', intStep );
        }
        if ( isNaN( intMinimumQuantity ) === true ) {
            intMinimumQuantity = 1;
            console.log( 'intMinimumQuantity value NaN, set to default', intMinimumQuantity );
        }
        if ( isNaN( intInputCurrentValue ) === true ) {
            intInputCurrentValue = 0;
            console.log( 'intInputCurrentValue value NaN, set to default', intInputCurrentValue );
        }
        intInputNewValue = intInputCurrentValue;
        if ( intInputCurrentValue < intMinimumQuantity ) {
            //show minimum tooltip
            intInputNewValue = intMinimumQuantity;
            console.log( 'minimum value corrected' );
        }
        if ( intStep !== 1 && intInputNewValue % intStep !== 0 ) {
            //show colli/step tooltip
            intInputNewValue = Math.ceil( ( intInputNewValue + 1 ) / intStep ) * intStep;
            console.log( 'colli value corrected' );
        }
        if ( intInputNewValue !== intInputCurrentValue ) {
            //show tooltip
            jInput.val( intInputNewValue ).trigger( 'change' ).valid();
            console.info( 'Updating quantity value from ' + intInputCurrentValue + ' to ' + intInputNewValue + '' );
        }
        var intModulusQuantityByStep = intMinimumQuantity % intStep;
        if ( intModulusQuantityByStep !== 0 ) {
            console.warn( 'Modulus of intMinimumQuantity(' + intMinimumQuantity + ') by intStep(' + intStep + ') is not zero(' + intModulusQuantityByStep + '). Validation accuracy will suffer.' );
        }
    },
    updateQuantityPrice: function ( domNode ) {
        var jForm = jQuery( domNode ),
            arrPrices = null;
        e4.jsonpublisher.getJsonFromUrl( e4.settings.ecom.product.url, {
            productId: e4.product.variants.getProductId( domNode ),
            variantId: e4.product.variants.getVariantId( domNode ),
        }, true ).done( function ( jsonProduct ) {
            arrPrices = e4.data.getObjectValueByPropertyPath( 'prices', jsonProduct );
            if ( arrPrices !== null && arrPrices.length > 0 ) {
                var intQuantityInput = parseInt( jForm.find( '.js-e-add-to-cart-quantity-input' ).val() );
                if ( isNaN( intQuantityInput ) === false ) {
                    for ( var i = arrPrices.length - 1; i >= 0; i-- ) {
                        if ( arrPrices[ i ].appliesAtQuantity <= intQuantityInput || i === 0 ) {
                            console.log( 'calc price using appliesAtQuantity', arrPrices[ i ].appliesAtQuantity, 'with quantity', intQuantityInput, 'giving unit price', arrPrices[ i ].value );
                            jForm.closest( '.js-e-product, .js-alcadon-add-to-cart-modal' ).find( '.js-alcadon-product-price' ).find( '.e-price-value' ).html( e4.util.formatJavascriptNumberToLocaleString( arrPrices[ i ].value * intQuantityInput ) );
                            break;
                        }
                    }
                }
            }
        } );
    },
    variants: {
        bindVariantsOnModalForm: function ( jModal ) {
            var jProductForm = jModal.find( '.js-e-product-form' );

            if ( jProductForm.length === 1 && jProductForm.data( 'hasVariants' ) === true ) {
                jModal.find( '.js-alcadon-add-to-cart-modal-form-container' ).addClass( 'js-e-product' );
                e4.product.variants.event = e4.util.registerEvents( 'change changed', 'product.variants' );
                e4.product.variants.updateAvailableOptionsInAllGroups( jProductForm.get( 0 ) );
                e4.product.variants.loadJsonProduct( jProductForm.get( 0 ) );
                e4.product.variants.bindEvents( jModal );
                alcadon.ecom.variants.bindEvents( jModal );
            }
        },
        bindEvents: function ( jModal ) {
            var jProduct = jModal.find( '.js-e-product' );
            jProduct.on( 'changed.e4.product.variants', function ( event, objData ) {
                jQuery( '.js-e-product-image-primary' ).attr( 'src', objData.imagePrimary.medium );
                jQuery( '.js-e-product-link' ).attr( 'href', objData.link );
            } );
        }
    },
    youtubeVideo: {
        init: function () {
            alcadon.ecom.youtubeVideo.bindEvents();
        },
        bindEvents: function () {
            jQuery( '#js-e-product-images-modal-carousel, #js-e-product-image-carousel' ).on( 'slide.bs.carousel', function ( event ) {
                var intFromIndex = event.from,
                    jCarouselItemByIndex = jQuery( event.target ).find( '.carousel-item[data-index="' + intFromIndex + '"]' ),
                    jVideoIframe = jCarouselItemByIndex.find( '.js-alcadon-youtube-iframe' );
                if ( jVideoIframe.length === 1 ) {
                    alcadon.ecom.youtubeVideo.pause( jVideoIframe );
                }

            } );
        },
        play: function ( jVideoIframe ) {
            alcadon.ecom.youtubeVideo.postMessageToIframe( jVideoIframe, 'playVideo' );
        },
        stop: function ( jVideoIframe ) {
            alcadon.ecom.youtubeVideo.postMessageToIframe( jVideoIframe, 'stopVideo' );
        },
        pause: function ( jVideoIframe ) {
            alcadon.ecom.youtubeVideo.postMessageToIframe( jVideoIframe, 'pauseVideo' );
        },
        postMessageToIframe: function ( jVideoIframe, strMessage ) {
            jVideoIframe[ 0 ].contentWindow.postMessage( '{"event":"command","func":"' + strMessage + '","args":""}', '*' );
        }
    },
    generateGuid: function () {
        /* jshint ignore:start */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function ( char ) {
            var result = Math.random() * 16 | 0, v = char === 'x' ? result : ( result & 0x3 | 0x8 );
            return v.toString( 16 );
        } );
        /* jshint ignore:end */
    }
};

alcadon.projects = {
    init: function () {
        alcadon.projects.bindEvents();
        alcadon.projects.setProjectListItemCallee();
    },
    bindEvents: function () {
        jQuery( '.js-alcadon-project-list' ).on( 'click', '.js-alcadon-add-to-cart-modal-btn', function ( event ) {
            alcadon.projects.validateCartAction( event );
        } );
        jQuery( '.js-alcadon-project-confirmation-modal' ).on( 'hide.bs.modal', function () {
            var jProjectSelect = jQuery( '.js-alcadon-cart-project-selector-input' ),
                strCurrentProjectNumber = jProjectSelect.data( 'currentProject' );
            if ( jProjectSelect.val() !== strCurrentProjectNumber ) {
                jProjectSelect.val( strCurrentProjectNumber );
            }
        } );
        jQuery( '.js-alcadon-add-to-cart-modal' ).on( 'submit', '.js-e-product-form-addtocart', function ( event ) {
            event.preventDefault();
            jQuery( event.delegateTarget ).modal( 'hide' );
            e4.product.addToCart( event.target );
        } );
        jQuery( '.js-alcadon-project-confirmation-accept-btn' ).on( 'click', function () {
            if ( jQuery( '.js-alcadon-project-list' ).length === 1 ) {
                alcadon.projects.changeProjectInList();
            }
            else if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
                alcadon.projects.changeProjectInCart();
            }
        } );
        jQuery( document ).on( 'change', '.js-alcadon-cart-project-selector-input', function ( event ) {
            alcadon.projects.setCurrentProjectInCart( event.target );
        } );
        jQuery( document ).on( 'close.bs.alert', '.js-alcadon-project-quantity-warning', function ( event ) {
            alcadon.projects.resetOrderlineWarning( event.target );
        } );
    },
    setProjectListItemCallee: function () {
        var calleeIndex = sessionStorage.getItem( 'alcadon.calleeIndex' );
        if ( calleeIndex !== null ) {
            var intCalleeIndex = parseInt( calleeIndex ),
                domCallee = jQuery( '.js-alcadon-project-list' ).find( '.js-e-productlist-item' ).filter( function ( index ) {
                    return index === intCalleeIndex;
                } );
            if ( domCallee !== null ) {
                jQuery( domCallee ).find( '.js-alcadon-add-to-cart-modal-btn' ).trigger( 'click' );
            }
            sessionStorage.removeItem( 'alcadon.calleeIndex' );
        }
    },
    setCurrentProjectInCart: function ( domNode ) { //function name credit goes to D.Broch
        var strSelectedProject = domNode.value,
            strCurrentProject = jQuery( domNode ).data( 'currentProject' );
        if ( strSelectedProject !== '' ) {
            if ( strCurrentProject === '' || strSelectedProject === strCurrentProject ) {
                alcadon.projects.changeProjectInCart();
            }
            else {
                var jConfirmationModal = jQuery( '.js-alcadon-project-confirmation-modal' );
                jConfirmationModal.find( '.js-alcadon-project-confirmation-modal-current-project' ).text( strCurrentProject );
                jConfirmationModal.find( '.js-alcadon-project-confirmation-modal-new-project' ).text( strSelectedProject );
                jConfirmationModal.modal( 'show' );
            }
        }
        else {
            alcadon.projects.clearProject().done( function ( jsonData ) {
                e4.cart.updateContent( jsonData );
                e4.cart.updateProjectInfo( jsonData.cart );
            } );
        }
    },
    resetOrderlineWarning: function ( domNode ) {
        var orderlineId = jQuery( domNode ).closest( '.js-e-orderline' ).attr( 'id' ),
            dataObj = {
                CartCmd: 'updateorderlines',
                Redirect: false
            };
        dataObj[ 'OrderLineFieldValue_' + orderlineId + '_AlcadonIsQuantityAdjustedToProjectMax' ] = '';
        dataObj[ 'OrderLineFieldValue_' + orderlineId + '_AlcadonProjectLineQuantityRemaining' ] = '';
        e4.cart.ajax( {
            data: dataObj
        } );
    },
    clearProject: function () {
        return e4.cart.ajax( {
            data: {
                AlcadonClearProject: true,
                AlcadonChangeProject: false,
                AlcadonProjectId: '',
                AlcadonProjectName: ''
            }
        } );
    },
    validateCartAction: function ( event ) {
        var jProjectList = jQuery( '.js-alcadon-project-list' ),
            strCurrentProject = jProjectList.data( 'currentProjectId' ),
            strProjectAddingToCart = jProjectList.data( 'projectId' );
        event.preventDefault();
        event.stopImmediatePropagation();
        if ( strCurrentProject !== '' && strCurrentProject !== strProjectAddingToCart ) {
            var intCalleeIndex = jQuery( event.target ).closest( '.js-e-productlist-item' ).parent().index();
            jQuery( '.js-alcadon-project-confirmation-modal' ).data( 'calleeIndex', intCalleeIndex ).modal( 'show' );
        }
        else {
            alcadon.ecom.loadProductForm( event.target );
        }
    },
    changeProjectInCart: function () {
        var jProjectSelect = jQuery( '.js-alcadon-cart-project-selector-input' ),
            strProjectId = jProjectSelect.val(),
            strProjectName = jProjectSelect.find( 'option:selected' ).data( 'projectName' );
        e4.cart.ajax( {
            data: {
                AlcadonProjectId: strProjectId,
                AlcadonProjectName: strProjectName,
                AlcadonChangeProject: true
            }
        }, function ( jsonData ) {
            e4.cart.updateContent( jsonData );
            e4.cart.updateProjectInfo( jsonData.cart );
        } );
    },
    changeProjectInList: function () {
        var jModal = jQuery( '.js-alcadon-project-confirmation-modal' ),
            intCalleeIndex = jModal.data( 'calleeIndex' ),
            jProjectList = jQuery( '.js-alcadon-project-list' );
        jQuery.ajax( {
            url: jProjectList.data( 'feedUrl' ),
            data: {
                AlcadonProjectId: jProjectList.data( 'projectId' ),
                AlcadonProjectName: jProjectList.data( 'projectName' ),
                AlcadonChangeProject: true
            }
        } ).done( function () {
            sessionStorage.setItem( 'alcadon.calleeIndex', intCalleeIndex );
            location.reload();
        } );
    }
};

